import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FacebookNotBorderIcon, InstagramIcon, InstagramNotBorderIcon, LinkedInIcon, LinkedInNotBorderIcon, MailIcon, MailNotBorderIcon, XNotBorderIcon } from "../icons/Icons";

const Footer = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const navigateToMail = () => {
    window.location.href = "mailto:support@vitrine.live";
  };

  const navigateToFacebook = () => {
    // window.open("https://www.facebook.com/vitrinelive", "_blank");
    window.open("https://www.facebook.com/profile.php?id=100093002800474", "_blank");
  };

  const navigateToLinkedIn = () => {
    window.open("https://www.linkedin.com/company/vitrinelive/", "_blank");
  };

  const navigateToX = () => {
    window.open("https://x.com/vitrine_live?s=21&t=RIJgSPeiVhMOIy5-Xqd9ww/", "_blank");
  };

  const navigateToInstagram = () => {
    window.open("https://instagram.com/vitrine_live?igshid=MzMyNGUyNmU2YQ==/", "_blank");
  };

  return (
    <>
      <footer className="position-relative overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-12 pt-5">
              <div className="d-flex justify-content-center">
                <img
                  src="/assets/images/LP-logo.svg"
                  alt="Vitrine"
                  width={250}
                />
              </div>
              <p className="col-md-9 text-center m-auto p-4">
                Collaboration made easy!
              </p>
              <ul className="navbar-nav footer-nav d-flex flex-row justify-content-center border-bottom pb-md-5">
                <li className="nav-item">
                  <Link className="nav-link" to="/about">
                    About Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/mainHelp">
                    Help Center
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/termsAndConditions">
                    Terms and Conditions
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/privacy-policy">
                    Privacy Policy
                  </Link>
                </li>
                <li className="nav-item">
                  <div onClick={() => {
                    navigate("/contactUs", { state: { from: location.pathname } });
                  }} className="nav-link cursor-pointer">
                    Contact Us
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-12 copyright-div pt-4 pb-4">
              <div className="row align-items-center">
                <div className="col-12 col-md-6">
                  <p className="m-0">
                    Copyright © 2025. All Rights Reserved By Vitrine
                  </p>
                </div>
                <div className="col-12 col-md-6">
                  <ul className="d-flex flex-row justify-content-md-end justify-content-center p-0 m-0">

                    <li
                      onClick={navigateToMail}
                      className="d-flex justify-content-center align-items-center ms-3 tw-border-none">
                      <MailNotBorderIcon />
                    </li>

                    <li
                      onClick={navigateToFacebook}
                      className="d-flex justify-content-center align-items-center ms-3 tw-border-none">
                      <FacebookNotBorderIcon />
                    </li>

                    <li
                      onClick={navigateToInstagram}
                      className="d-flex justify-content-center align-items-center ms-3 tw-border-none">
                      <InstagramNotBorderIcon />
                    </li>

                    <li
                      onClick={navigateToLinkedIn}
                      className="d-flex justify-content-center align-items-center ms-3"
                    >
                      <LinkedInNotBorderIcon />
                    </li>

                    <li
                      onClick={navigateToX}
                      className="d-flex justify-content-center align-items-center ms-3">
                      <XNotBorderIcon />
                    </li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-ft-shape position-absolute" />
        <img
          src="/assets/images/left-footimg-opt.png"
          className="left-footimg img-fluid position-absolute"
          alt="..."
        />
        <img
          src="/assets/images/right-footimg-opt.png"
          className="right-footimg img-fluid position-absolute "
          alt="..."
        />
      </footer>
    </>
  );
};

export default Footer;

